import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "pt-2",
  style: {"width":"100%"}
}
const _hoisted_2 = { class: "mb-4 text-caption" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn_add = _resolveComponent("v-btn-add")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_virtual_scroll = _resolveComponent("v-virtual-scroll")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_Scope = _resolveComponent("Scope")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, { class: "default_card_admin" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, {
          fluid: "",
          "grid-list-md": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { class: "pb-2" }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createElementVNode("h2", null, "Périmètre", -1)
              ])),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "align-center" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "flex-grow-1 flex-shrink-0",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openEdition()))
                }, [
                  _createVNode(_component_v_text_field_filled, {
                    "model-value": _ctx.computedName,
                    placeholder: "Aucun perimètre choisi",
                    readonly: "",
                    density: "compact",
                    class: "mr-3 pointer_text_field",
                    "append-inner-icon": "$oss-eye",
                    "data-cy": "ScopeManager-perimetre"
                  }, null, 8, ["model-value"])
                ]),
                _createVNode(_component_v_btn, {
                  size: "small",
                  elevation: "0",
                  rounded: "",
                  color: "primary",
                  onClick: _ctx.openDialog,
                  disabled: _ctx.readonly
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "large",
                      left: ""
                    }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode("$oss-article")
                      ])),
                      _: 1
                    }),
                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "pl-2" }, "Choisir", -1))
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dialog) = $event)),
      eager: true,
      onValid: _ctx.valid,
      validDisabled: !_ctx.validName,
      hideValid: _ctx.currentStep === 'selectScope',
      validTitle: _ctx.validTitle,
      width: "60vw",
      onPrevious: _ctx.previousStep,
      "previous-display": ['createScope'].includes(_ctx.currentStep),
      onAfterEnter: _ctx.scrollToIndex,
      onClose: _ctx.closeDialog
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window, {
          modelValue: _ctx.currentStep,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.currentStep) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_window_item, { value: "selectScope" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_v_col, { class: "d-flex justify-start align-center flex-grow-1 flex-shrink-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field_filled, {
                        label: "Rechercher",
                        modelValue: _ctx.searchScope,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchScope) = $event)),
                        outlined: "",
                        density: "compact"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_btn_add, {
                        rounded: "xl",
                        class: "ml-2",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setEditScope({id: null})))
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_virtual_scroll, {
                    ref: "virtualScroll",
                    benched: 20,
                    items: _ctx.filteredScopeList,
                    height: "500",
                    "item-height": "64",
                    class: "mx-2"
                  }, {
                    default: _withCtx(({ item }) => [
                      (_openBlock(), _createBlock(_component_v_list_item, {
                        key: (item as any).id,
                        class: _normalizeClass(
                                    !_ctx.$vuetify.display.mobile
                                        ? 'mb-2 oss-list-item'
                                        : 'mb-2 px-2 oss-list-item'
                                ),
                        border: "sm",
                        variant: "outlined",
                        rounded: "xl",
                        density: "comfortable",
                        style: {"height":"70px"},
                        disabled: _ctx.isReadonly(item)
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_checkbox_btn, {
                            density: "comfortable",
                            "model-value": _ctx.idSync === (item as any).id,
                            "onUpdate:modelValue": ($event: any) => (_ctx.selectScopes(item)),
                            color: "primary",
                            class: "pr-3 pa-0"
                          }, null, 8, ["model-value", "onUpdate:modelValue"])
                        ]),
                        append: _withCtx(() => [
                          _createVNode(_component_v_btn_icon, {
                            icon: "$oss-edit",
                            onClick: _withModifiers(($event: any) => (_ctx.setEditScope(item)), ["stop"]),
                            size: "small"
                          }, null, 8, ["onClick"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString((item as any).name || "_"), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_list_item_subtitle, null, {
                            default: _withCtx(() => [
                              _createElementVNode("small", _hoisted_2, _toDisplayString(_ctx.getCountName(item)), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_list_item_subtitle, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTargets(item), (value, key) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: (item as any).name + key
                                }, [
                                  value
                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 0,
                                        label: "",
                                        class: "mr-2",
                                        size: "x-small"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(value), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["class", "disabled"]))
                    ]),
                    _: 1
                  }, 8, ["items"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: "createScope" }, {
              default: _withCtx(() => [
                _createVNode(_component_Scope, {
                  ref: "refScope",
                  modelValue: _ctx.scopeSync,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.scopeSync) = $event)),
                  id: _ctx.scopeId,
                  "onUpdate:id": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.scopeId) = $event)),
                  name: _ctx.nameSync,
                  "onUpdate:name": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.nameSync) = $event)),
                  initialCompany: _ctx.initialCompany,
                  accountingFirmId: _ctx.accountingFirmId,
                  returnScopedCompanies: _ctx.returnScopedCompanies,
                  hideCompany: _ctx.hideCompany,
                  hideActivity: _ctx.hideActivity,
                  hideTaxSystem: _ctx.hideTaxSystem,
                  onScopedCompanies: _ctx.onScopedCompaniesChanged,
                  onValidName: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validName = $event))
                }, null, 8, ["modelValue", "id", "name", "initialCompany", "accountingFirmId", "returnScopedCompanies", "hideCompany", "hideActivity", "hideTaxSystem", "onScopedCompanies"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "onValid", "validDisabled", "hideValid", "validTitle", "onPrevious", "previous-display", "onAfterEnter", "onClose"])
  ], 512)), [
    [_vShow, !_ctx.isBusinessClientWithSingleCompany]
  ])
}